import { IMDSDateRangePickerProps } from "./date-range-picker.types";
import {
  StyledDateRangePicker,
  StyledGroup,
  LabelWrapper,
  Dash,
  StyledButton,
} from "./date-range-picker.style";
import { MDSDateSegment, MDSRangeCalendar } from "@/mds/components/date-time";
import { MDSButtonVariant } from "@/mds/components/buttons/button";
import { MDSDateInput } from "@/mds/components/forms";
import { MDSLabel } from "@/mds/components/forms/label";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { MDSDateField } from "@/mds/components/date-time/date-field";
import { useState } from "react";
import { Dialog } from "react-aria-components";
import { MDSPopover } from "@/mds/components/overlays";

export function MDSDateRangePicker(props: IMDSDateRangePickerProps) {
  const { label, ...rest } = props;
  const [isOpen, setIsOpen] = useState(false);

  const arrowType = isOpen ? MdsIconKind.DropdownOpened : MdsIconKind.DropdownClosed;

  return (
    <StyledDateRangePicker {...rest} onOpenChange={setIsOpen}>
      {label && (
        <LabelWrapper>
          <MDSLabel>{label}</MDSLabel>
        </LabelWrapper>
      )}
      <StyledGroup>
        <MDSDateField slot="start">
          <MDSDateInput>{segment => <MDSDateSegment segment={segment} />}</MDSDateInput>
        </MDSDateField>
        <Dash aria-hidden="true">–</Dash>
        <MDSDateField slot="end">
          <MDSDateInput>{segment => <MDSDateSegment segment={segment} />}</MDSDateInput>
        </MDSDateField>
        <StyledButton variant={MDSButtonVariant.Transparent}>
          <MdsIcon kind={arrowType} />
        </StyledButton>
      </StyledGroup>
      <MDSPopover>
        <Dialog>
          <MDSRangeCalendar />
        </Dialog>
      </MDSPopover>
    </StyledDateRangePicker>
  );
}
